import { apiClient } from './api.client';

export interface AttendanceCodeMap {
  // ── Core types (always present via Attendance Code Settings) ─────────────
  'Full Day Present': string;
  'Absent': string;
  'Full Day Leave': string;
  'Half Day Leave': string;
  'Week Off': string;
  'Holiday': string;
  'National Holiday': string;
  'Festival Holiday': string;
  'OT Day': string;
  'Loss Of Pay': string;
  // ── Backward-compat: may be present for companies migrating from old split-variant settings ──
  'Half Day Present'?: string;
  // ── Custom / future types ──────────────────────────────────────────────────
  [key: string]: string | undefined;
}

export async function fetchActiveAttendanceCodes(): Promise<AttendanceCodeMap> {
  const { data } = await apiClient.get<AttendanceCodeMap>('/attendancecodesettings/active');
  return data;
}
